export const PAGINATION_PAGE_SIZE: number = 20;



// WEBPACK FOOTER //
// ./src/store/pagination/paginationConfig.ts